import commonMapping from "@/mapping/common";

export const ipmac = {
  ipmac_enable: commonMapping.intToBoolean,
};

export default ipmac;
